import React from 'react'
import NotFoundPage from '../features/NotFound/NotFoundPage';

function NotFound() {
   return(
    <div>
         <NotFoundPage/>
    </div>
   )
     
}

export default NotFound;
